import React from "react";
import { FocusAreaDropdown, SearchReset, TextSearch} from "./components/Searchers.js";
import ModuleCards from "./components/ModuleCards.js";
import "./MainPage.css";
import "../ActionBytePages.css";
import { Container } from "react-bootstrap";


function MainPage(props) {
    /**
     * Component for the main action byte page containing listing of action bytes. Takes all imported sub-components and creates the full HTML page.
     * @param props: props passed down from the App component (action byte list, event handlers, and text query)
     * @returns: main page JSX component with header, catalog button, searchers, and module cards.
     */

    // Upon main page rendering, set the document title to the following string for display in browser tab
    document.title = `NASA SPoRT Action Bytes`;

    return (
        <div className="bg-image-sport body-sport">
            <br/>

            <Container className="dark-bg1-sport text-center mx-0 rounded">
                <h2>NASA SPoRT Action Bytes</h2>
                <h4 className="fst-italic">Explore examples of how SPoRT data helps stakeholders address real-world challenges and make informed decisions through brief (5 minutes or less) highlights of NASA data in action!</h4>
                <FocusAreaDropdown focusArea={props.focusArea} focusAreaHandler={props.focusAreaHandler}/>
                <SearchReset resetActionBytes={props.resetActionBytes}/>
                <TextSearch query={props.query} queryHandler={props.queryHandler}/>
            </Container>
            
            <br/>
            <ModuleCards actionBytesList={props.actionBytesList}/>

            
        </div>
    );
}

export default MainPage;